/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const useUtils = () => {
    const currentPage = (pathname) => {
        /*
         *
         * This regex matches
         * /en/test
         * /fr/test
         * /it-IT/test
         * /test
         *
         * but not
         * /other/test
         *
         */

        const isComponentsLibrary = /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/components-library/.test(
            pathname,
        )
        const isCheckout = /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/checkout/.test(pathname)
        const isCheckoutConfirmation = /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/checkout\/confirmation/.test(
            pathname,
        )
        const isRegistrationConfirmation =
            /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/registration\/confirmation/.test(pathname)
        const isRegistrationCompletePage =
            /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/registration\/complete/.test(pathname)
        const isCart = /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/cart/.test(pathname)
        const isProductDetail = /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/p\//.test(pathname)
        const isCategory = /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/c\//.test(pathname)
        const isMaintenance = /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/maintenance/.test(pathname)
        const isPaperless = /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/s\//.test(pathname)
        const isWishlistPage =
            /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/wishlist/.test(pathname) ||
            /^(\/[a-z]{2}(-[A-Za-z]{2})?)?\/account\/wishlist/.test(pathname)

        return {
            isCategory,
            isComponentsLibrary,
            isCheckout,
            isCheckoutConfirmation,
            isRegistrationConfirmation,
            isRegistrationCompletePage,
            isCart,
            isProductDetail,
            isMaintenance,
            isPaperless,
            isWishlistPage,
        }
    }

    return {
        currentPage,
    }
}

export default useUtils
